export interface PickerItem {
  id: string | number;
  title?: string;
  description?: string;
  [key: string]: unknown;
}

export interface PickerSubmitResult {
  /** Successful writes are removed from the draft even if a later write/refresh failed. */
  completedIds?: Array<string | number>;
  error?: string;
}

export type PickerCategory =
  | 'properties'
  | 'technicalReports'
  | 'products'
  | 'propertySets'
  | 'technicalReportSets';

interface PickerDetail {
  property_set?: Array<{
    property_definition?: { classified_id?: string | number };
    value?: unknown;
  }>;
  technical_report_item_set?: PickerItem[];
  reference_product_set?: PickerItem[];
}

export function existingPickerItems(
  detail: PickerDetail | undefined,
  category: PickerCategory,
  multi = false
): PickerItem[] {
  if (category === 'properties') {
    return (detail?.property_set || []).flatMap((row) => {
      if (multi && !('value' in row)) return [];
      const id = row.property_definition?.classified_id;
      return id == null ? [] : [{ id }];
    });
  }
  if (category === 'technicalReports')
    return (detail?.technical_report_item_set || []).filter((row) => !multi || !row.diff_flag);
  if (category === 'products') return detail?.reference_product_set || [];
  return [];
}
